import React from "react";
import PropTypes from "prop-types";

import { useTooltip } from "../../hooks/useTooltip";

export default function EstimateTr({ estimate, columns, children }) {
  // convert object properties to strings
  const updatedAt = estimate.updatedAt ? String(estimate.updatedAt.toDate()) : null;

  const safeEstimate = {
    ...estimate,
    updatedAt,
  }

  return (
    <tr>
      {columns.map((column, i) => {
        return <td key={i}>{safeEstimate[column]}</td>;
      })}
      {children}
    </tr>
  );
}

EstimateTr.propTypes = {
  estimate: PropTypes.object,
  columns: PropTypes.array,
  children: PropTypes.node,
};
